import animations from "create-keyframe-animation";
import BaseComponent from "../../../baseComponent.js";

export default class Animatable extends BaseComponent {
  constructor(props) {
    super(props);
    this.isInitialValue = true;
  }

  componentDidMount() {
    this.elementToHide = this.refs.elementOne;
    this.elementToShow = this.refs.elementTwo;


    $(this.refs.container).css({
      "font-family": this.props.data.fontFamily,
      "font-size": this.props.data.multiplier * this.props.baseFontSize,
      "font-weight": this.props.data.bold ? "bold" : "normal",
      "opacity": this.props.hidden ? 0 : '',
      "display": this.props.display === false ? 'none' : ''
    });
    $(this.refs.container).find(".animatable__value").css({
      "font-family": this.props.data.fontFamily,
      "color": this.props.data.color,
      "font-size": this.props.data.multiplier * this.props.baseFontSize,
      "font-weight": this.props.data.bold ? "bold" : "normal"
    });

    if (this.props.animate) {
      this.registerAnimations();
      // animations.runAnimation(this.elementToShow, 'animateOne');
    } else {
      $(this.elementToHide).text(this.props.value);
    }
  }

  componentWillUnmount() {
    this.unregisterAnimations();
  }

  componentWillReceiveProps(nextProps) {
    let currentValue = $(this.elementToHide).text();

    if (nextProps.value === ".") {
      if (!this.props.animate) {
        if (this.elementToShow.style.opacity === "0") {
          $(this.elementToHide).text(".");
        } else {
          $(this.elementToShow).text(".");
        }
      } else {
        $(this.elementToShow).text(".");
      }
      $(this.refs.container).find("span").text(".");
    } else {
      if (!this.props.animate) {
        if (this.elementToShow.style.opacity === "0") {
          $(this.elementToHide).text(nextProps.value);
        } else {
          $(this.elementToShow).text(nextProps.value);
        }
      } else {
        $(this.elementToHide).text(nextProps.value);
      }
    }

    if (this.isInitialValue) {
      $(this.elementToHide).text(nextProps.value);
      $(this.refs.container).css("opacity", "1");
      this.isInitialValue = false;
    } else if (currentValue !== nextProps.value && this.props.animate) {
      this.runAnimation();
    }

    $(this.refs.container).css({
      "opacity": nextProps.hidden ? 0 : ''
    });
  }

  registerAnimations() {
    let options = {
      duration: 700,
      easing: 'ease-in-out'
    };

    let animationDetail = this.getAnimations();

    animations.registerAnimation({
      name: "animateOne",
      animation: animationDetail[0],
      presets: options
    });

    animations.registerAnimation({
      name: "animateTwo",
      animation: animationDetail[1],
      presets: options
    });
  }

  unregisterAnimations() {
    animations.unregisterAnimation("animationOne");
    animations.unregisterAnimation("animationTwo");
  }

  getAnimations() {
    return [[
      {
        translate: [0, 0],
        opacity: 1
      },
      {
        translate: [0, -20],
        opacity: 0
      }
    ],
      [
        {
          translate: [0, -20],
          opacity: 0
        },
        {
          translate: [0, 0],
          opacity: 1
        }
      ]
    ]
  }

  runAnimation() {
    animations.runAnimation(this.elementToHide, 'animateOne');
    animations.runAnimation(this.elementToShow, 'animateTwo');

    let temp = this.elementToHide;
    this.elementToHide = this.elementToShow;
    this.elementToShow = temp;
  }

  render() {
    const style = {};
    if (!this.props.animate) {
      style.opacity = 0;
    }
    return (
      <div className="textual-animatable" ref="container" style={{opacity: this.props.hidden ? 0 : ''}}>
        <div className="animatable__value" ref="elementOne">{this.props.value === undefined ? 0 : this.props.value}</div>
        <div className="animatable__value" ref="elementTwo" style={style}>{this.props.value === undefined ? 0 : this.props.value}</div>
        <span>0</span>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/widgets/textual/animatable.jsx